import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params, Router } from '@angular/router';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';
import { MobileDeliverSoldVehicleService } from 'src/app/services/mobile/mobile-deliver-sold-vehicle.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-deliver-sold-vehicle',
  templateUrl: './deliver-sold-vehicle.component.html',
  styleUrls: ['./deliver-sold-vehicle.component.css']
})
export class DeliverSoldVehicleComponent implements OnInit{
  public vehicle_id: string = '';
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicle: any;
  spare_parts: any;
  searchText: string = '';
  selectedSpareParts: any[] = []; // Array to store selected spare parts
  selectedSparePartsIDs: any[] = []; // Array to store selected spare parts IDs
  @ViewChild('confirmAccessoriesModal') modalElement!: ElementRef;
  @ViewChild('addCustomerInfoModal') addCustomerInfoModal!: ElementRef;
  form!: FormGroup;
  submitted: boolean = false;
  isChecked: boolean = false;
  hasExternalDamage: boolean = false;
  locationId: any="";
  userId: any="";
  transferTo:string='Sold';
  transferReason:string='Delivery';

  constructor(
    private mobileVehiclesService: MobileVehiclesService,
    private mobileDeliverSoldVehicleService: MobileDeliverSoldVehicleService,
    private activatedRoute:ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private location: Location,
    private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      cust_name:['',Validators.required],
      cust_id_no:['',Validators.required],
      cust_phone_no:['',Validators.required],
      cust_address:['',Validators.required],
      hasExternalDamage: [false],
      comment:['']
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.isLoading=true;

      this.locationId=localStorage.getItem('locationId');
      this.userId=localStorage.getItem('userID');

      this.getVehicleData(this.vehicle_id);
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

   /**
   * Get vehicle details
   * @param vehicle_id
   */
   getVehicleData(vehicle_id: string): void{
    this.mobileVehiclesService.getVehicle(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load vehicle details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Unable to load vehicle details. Please refresh the page and try again.";
            this.toastr.error(this.errorMessage, 'Error!');
          }else{
            this.fetchSpareParts();
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  fetchSpareParts():void{
    this.mobileDeliverSoldVehicleService.getVehicleSpareParts()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.spare_parts = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

   // Function to handle checkbox change event
  checkboxChange(event: any, part: any) {

    if (event.target.checked) {

      this.selectedSpareParts.push({
        part_id: part.id,
        name: part.name
      });

    } else {

      const index = this.selectedSpareParts.findIndex(
        item => item.part_id === part.id
      );

      if (index !== -1) {
        this.selectedSpareParts.splice(index, 1);
      }
    }
  }

  openConfirmAccessoriesModal(){
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('show');
    }
  }

  closeConfirmAccessoriesModal():void {
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  confirmAccessories(){
    if(this.selectedSpareParts.length===0){
      this.toastr.error("Please select available spare parts to proceed!", 'Error!');
    }else{
      this.openConfirmAccessoriesModal();

      //Clear previously selected spare parts IDs
      this.selectedSparePartsIDs.length = 0;

      //Select spare parts IDs to submit
      this.selectedSpareParts.forEach(part => {
        this.selectedSparePartsIDs.push(
          part.part_id
        );
      });
    }
  }

  openAddCustomerInfoModal(){
    this.closeConfirmAccessoriesModal();

    if (this.addCustomerInfoModal) {
      (<any>$(this.addCustomerInfoModal.nativeElement)).modal('show');
    }
  }

  closeAddCustomerInfoModal(){
    if (this.addCustomerInfoModal) {
      (<any>$(this.addCustomerInfoModal.nativeElement)).modal('hide');
    }
  }

  /**
   * Toggle external damage checkbox
   */
  onCheckboxChange(): void {
    this.hasExternalDamage = this.form.get('hasExternalDamage')?.value;
  }

  /**
   * Deliver sold vehicle to customer
   */
  deliverVehicle(){
    this.submitted = true;
    this.isLoading=true;

    if(this.selectedSparePartsIDs.length===0){

      this.isLoading=false;
      let errorMessage="Please select spare parts to proceed!";
      this.toastr.error(errorMessage, 'Error!');

    }else{
      this.mobileDeliverSoldVehicleService.deliver(this.vehicle_id,this.vehicle.data.chassis_no,this.selectedSparePartsIDs, this.form.value.cust_name,this.form.value.cust_id_no,this.form.value.cust_phone_no,this.form.value.cust_address,this.transferReason,this.locationId,this.transferTo,this.hasExternalDamage,this.form.value.comment,this.userId)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            //Clear selected spare parts arrays
            this.selectedSpareParts.length = 0;
            this.selectedSparePartsIDs.length = 0;

            this.isLoading=false;  //Dismiss spinner
            this.closeAddCustomerInfoModal(); //Close modal

            // Store chassis No.,log Id and transaction type in session for use
            // when uploading photos
            localStorage.setItem('chassisNo', this.vehicle.data.chassis_no);
            localStorage.setItem('logId', response.log_id);
            localStorage.setItem('txnType', 'transfer');

            // Redirect to photos  screen
            this.toastr.success("Vehicle delivered successfully!", 'Success!');
            this.router.navigate(['mobile/vehicle-transfer-photos']);
          }else if(response.status==='error'){
            this.submitted = false;
            this.isLoading=false
            this.toastr.error(response.message, 'Error!');
          }else{
            this.submitted = false;
            this.isLoading=false;
            this.toastr.error("Vehicle Delivery failed. Please try again!", 'Error!');
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isLoading=false;
          this.toastr.error("An error occurred, please try again! ", 'Error!');
        }
      });
    }
  }

  goBack(): void {
    this.location.back();
  }
}
